// src/pages/Checkout.js
import { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { subscriptionPlans } from '../data/subscriptionPlans';

// TODO: Stripe integration
// 1. Install: npm install @stripe/react-stripe-js @stripe/stripe-js
// 2. Add REACT_APP_STRIPE_PUBLISHABLE_KEY to .env
// 3. Wrap this component with <Elements stripe={stripePromise}> in App.js or here
// 4. Replace the placeholder below with <PaymentElement /> from @stripe/react-stripe-js
// 5. On submit, call stripe.confirmPayment() with a clientSecret obtained from your
//    backend (Cloud Function) that creates a Stripe PaymentIntent or Subscription
// 6. On success, activate subscription via Stripe webhook — do NOT trust the client redirect

function Checkout() {
  const { planId } = useParams();
  const navigate = useNavigate();
  const [plan, setPlan] = useState(null);

  useEffect(() => {
    const selected = subscriptionPlans.find(p => p.id === planId);
    if (!selected) { navigate('/subscribe'); return; }
    setPlan(selected);
  }, [planId, navigate]);

  if (!plan) {
    return (
      <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span style={{ color: 'var(--text-mute)' }}>Indlæser…</span>
      </div>
    );
  }

  return (
    <div style={{ padding: '64px 20px', maxWidth: 520, margin: '0 auto' }}>
      <span className="fc-eyebrow">Betaling</span>
      <h1 style={{ fontSize: 32, fontWeight: 800, letterSpacing: '-0.03em', color: 'var(--text-primary)', marginBottom: 32 }}>
        Fuldfør dit abonnement
      </h1>

      {/* Order summary */}
      <div style={{
        background: 'var(--bg-card)',
        border: '1px solid var(--border-color)',
        borderRadius: 16,
        padding: '20px 24px',
        marginBottom: 24,
      }}>
        <div style={{ fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--text-mute)', marginBottom: 16 }}>
          Ordreoversigt
        </div>
        {[
          { label: plan.name, value: `${plan.price} ${plan.currency}` },
          { label: 'Til skaberne (80%)', value: `${(plan.price * 0.8).toFixed(2)} ${plan.currency}` },
          { label: 'Faircast drift (20%)', value: `${(plan.price * 0.2).toFixed(2)} ${plan.currency}` },
        ].map((row, i) => (
          <div key={i} style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px 0',
            fontSize: 14,
            borderBottom: i < 2 ? '1px solid var(--border-color)' : 'none',
          }}>
            <span style={{ color: i === 0 ? 'var(--text-primary)' : 'var(--text-secondary)', fontWeight: i === 0 ? 700 : 400 }}>{row.label}</span>
            <span style={{
              fontFamily: "'JetBrains Mono', monospace",
              fontWeight: 700,
              color: i === 0 ? 'var(--text-primary)' : 'var(--text-mute)',
            }}>{row.value}</span>
          </div>
        ))}
      </div>

      {/* Stripe placeholder */}
      <div style={{
        background: 'var(--bg-card)',
        border: '1px solid var(--border-color)',
        borderRadius: 16,
        padding: '24px',
        marginBottom: 24,
      }}>
        <div style={{ fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em', color: 'var(--text-mute)', marginBottom: 20 }}>
          Betalingsinformation
        </div>

        {/* STRIPE PAYMENT ELEMENT GOES HERE */}
        <div style={{
          border: '2px dashed var(--border-strong)',
          borderRadius: 12,
          padding: '36px 24px',
          textAlign: 'center',
          color: 'var(--text-mute)',
          marginBottom: 20,
        }}>
          <div style={{ fontSize: 24, marginBottom: 8 }}>💳</div>
          <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 4 }}>Stripe betalingsformular</div>
          <div style={{ fontSize: 12 }}>Monteres her — se TODO-kommentaren øverst i filen</div>
        </div>

        <button
          type="button"
          disabled
          style={{
            width: '100%',
            padding: '14px 0',
            borderRadius: 10,
            border: 'none',
            background: 'var(--bg-elevated)',
            color: 'var(--text-mute)',
            fontWeight: 700,
            fontSize: 15,
            cursor: 'not-allowed',
          }}
        >
          Betal {plan.price} {plan.currency} — afventer Stripe
        </button>
      </div>

      <p style={{ fontSize: 13, color: 'var(--text-mute)', lineHeight: 1.6, textAlign: 'center', marginBottom: 16 }}>
        Dit abonnement starter øjeblikkeligt. Du kan til enhver tid opsige.
        Ved at abonnere accepterer du vores{' '}
        <a href="/terms" style={{ color: 'var(--primary-color)', textDecoration: 'none' }}>vilkår</a> og{' '}
        <a href="/privacy" style={{ color: 'var(--primary-color)', textDecoration: 'none' }}>privatlivspolitik</a>.
      </p>

      <div style={{ textAlign: 'center' }}>
        <Link to="/subscribe" style={{ color: 'var(--text-mute)', fontSize: 13, textDecoration: 'underline' }}>
          ← Tilbage til planvalg
        </Link>
      </div>
    </div>
  );
}

export default Checkout;
